module.exports = __webpack_public_path__ + "static/img/p4.2acf833d.png";